if (!customElements.get('tractor-animation')) {
	class TractorAnimation extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			let start;
			let pauseStart;
			let isPaused = false;
			function step(timestamp) {
				if (start === undefined) {
					start = timestamp;
				}

				if (isPaused) {
					const pauseElapsed = timestamp - pauseStart;
					if (pauseElapsed > 1000) {
						this.style.transform = `translateX(calc(-100% + 0px))`;
						isPaused = false;
						start = timestamp;
					}
				} else {
					const elapsed = timestamp - start;
					const transformVal = elapsed / 10;
					this.style.transform = `translateX(calc(-100% + ${transformVal}px))`;
					if (transformVal > window.innerWidth + this.clientWidth) {
						isPaused = true;
						pauseStart = timestamp;
					}
				}

				requestAnimationFrame(step.bind(this));
			}

			requestAnimationFrame(step.bind(this));
		}
	}

	customElements.define('tractor-animation', TractorAnimation);
}

